import { useNavigate } from 'react-router-dom';

export function CNS() {
  const navigate = useNavigate();

  const platforms = [
    {
      name: 'Youtube Playlists',
      logo: 'https://thumbs.dreamstime.com/b/high-resolution-colored-youtube-logo-white-background-vector-eps-file-available-additional-download-colored-youtube-logo-175730434.jpg',
      route: '/Cyber_CNS_Yt',
    },
    {
      name: 'Coursera',
      logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmVgLGfhr0DKM1D4bBSvZh9h6UdIG84qhbSsHAsn_P1KeOEa_wGqqbO9z1zcyn3atADVU&usqp=CAU',
      route: '/Cyber_CNS_Coursera',
    },
    {
      name: 'Udemy Courses',
      logo: 'https://logowik.com/content/uploads/images/udemy-new-20212512.jpg',
      route: '/Cyber_CNS_Udemy',
    },
    {
      name: 'Geeks For Geeks',
      logo: 'https://miro.medium.com/v2/resize:fit:799/0*yxCtOgS-v50Sqfzw.jpeg',
      route: '/Cyber_CNS_Gfg',
    },
  ];

  return (
    <>
      <h1 className="html_head">Links are below</h1>
      <p className="html_para">
        These are the platforms for your <strong>Computer Networking System</strong> study purpose.
        Utilize these recommended platforms to explore and gain knowledge for practice. This is not for promotions but for the <strong>educational purpose</strong> to explore more in less time.
      </p>

      <h3 className="reco_html">Recommended Platforms</h3>

      {platforms.map((platform, index) => (
        <div className="container_html_pg" key={index}>
          <img
            className="html_logo_yt"
            style={{ height: '90px', width: '90px' }}
            src={platform.logo}
            alt={`${platform.name} Logo`}
          />
          <h5 style={{ margin: '30px 0px 0px 30px', fontFamily: 'Arial', fontWeight: 'bold' }}>
            {platform.name} &#9754;
          </h5>
          <div className="butt_yt">
            <button className="btn_html_yt" onClick={() => navigate(platform.route)}>
              Click Me
            </button>
          </div>
        </div>
      ))}
    </>
  );
}

export default CNS;
